import { render, staticRenderFns } from "./AgentSessionDetails.vue?vue&type=template&id=7819d205&scoped=true&"
import script from "./AgentSessionDetails.vue?vue&type=script&lang=js&"
export * from "./AgentSessionDetails.vue?vue&type=script&lang=js&"
import style0 from "./AgentSessionDetails.vue?vue&type=style&index=0&id=7819d205&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7819d205",
  null
  
)

export default component.exports